import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useState } from "react";
import { ValidationError } from "yup";
import { AuthPasswordInput } from "../../modules/Auth/components/AuthPasswordLayout/AuthPassword.styles";
import PasswordCriteriaChecklist from "./PasswordCriteriaChecklist";
import { passwordValidationSchema } from "./schema";

export const Password = props => {
  const {
    form,
    showToggle,
    name = "password",
    variant = "list",
    id,
  } = props;
  const [errors, setErrors] = useState([]);
  const [show, setShow] = useState(false);

  const validatePassword = async value => {
    form.setFieldValue(name, value);

    if (name !== "password" || !value) {
      setErrors([]);
      return;
    }

    try {
      await passwordValidationSchema.validate(value, {
        abortEarly: false,
        context: {
          name: form.values.name,
        },
      });

      setErrors([]);
    } catch (error) {
      if (error instanceof ValidationError) {
        setErrors(error.errors || []);
      }
    }
  };

  const isInvalid = form.errors[name] && form.touched[name];
  const passwordValue = form.values[name] || "";

  if (variant === "checklist") {
    return (
      <>
        <div style={{ position: "relative" }}>
          <AuthPasswordInput
            id={id}
            type={show ? "text" : "password"}
            name={name}
            autoComplete={props.autoComplete || "new-password"}
            $hasError={Boolean(isInvalid)}
            style={showToggle ? { paddingRight: "2.5rem" } : undefined}
            value={passwordValue}
            onChange={e => validatePassword(e.target.value)}
            onBlur={() => form.setFieldTouched(name, true)}
          />
          {showToggle && (
            <button
              type="button"
              aria-label={show ? "Ocultar senha" : "Mostrar senha"}
              onClick={() => setShow(s => !s)}
              className="text-muted bg-transparent border-0 p-0"
              style={{
                position: "absolute",
                right: "0.75rem",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
              }}
            >
              {show ? (
                <VisibilityOffIcon
                  fontSize="small"
                  sx={{ color: "#6c757d !important" }}
                />
              ) : (
                <VisibilityIcon
                  fontSize="small"
                  sx={{ color: "#6c757d !important" }}
                />
              )}
            </button>
          )}
        </div>
        <PasswordCriteriaChecklist password={passwordValue} />
        {form.errors[name] && form.touched[name] ? (
          <p
            style={{
              color: "#e53935",
              fontSize: 14,
              margin: "8px 0 0",
              fontFamily: '"Noto Sans", sans-serif',
            }}
          >
            {form.errors[name]}
          </p>
        ) : null}
      </>
    );
  }

  return (
    <>
      <div style={{ position: "relative" }}>
        <input
          type={show ? "text" : "password"}
          name={name}
          id={id}
          autoComplete={props.autoComplete || "off"}
          className={`form-control ${props.className || ""} ${
            isInvalid ? "is-invalid" : ""
          }`}
          style={
            showToggle
              ? { paddingRight: "2.5rem", backgroundImage: "none" }
              : undefined
          }
          value={passwordValue}
          onChange={e => validatePassword(e.target.value)}
          onBlur={() => form.setFieldTouched(name, true)}
        />
        {showToggle && (
          <button
            type="button"
            aria-label={show ? "Ocultar senha" : "Mostrar senha"}
            onClick={() => setShow(s => !s)}
            className="text-muted bg-transparent border-0 p-0"
            style={{
              position: "absolute",
              right: "0.75rem",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
            }}
          >
            {show ? (
              <VisibilityOffIcon
                fontSize="small"
                sx={{ color: "#6c757d !important" }}
              />
            ) : (
              <VisibilityIcon
                fontSize="small"
                sx={{ color: "#6c757d !important" }}
              />
            )}
          </button>
        )}
      </div>
      {errors.length > 0 && (
        <ul
          className="invalid-feedback"
          style={{ display: "block", paddingTop: 8 }}
        >
          {errors.map((error, index) => (
            <li key={index}>{error}</li>
          ))}
        </ul>
      )}
      {!errors.length && form.errors[name] && form.touched[name] ? (
        <p
          className="invalid-feedback"
          style={{ display: "block", margin: 0 }}
        >
          {form.errors[name]}
        </p>
      ) : null}
    </>
  );
};
